var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMergedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6922 14.1922L12.9422 17.9422C12.8249 18.0595 12.6659 18.1253 12.5 18.1253C12.3341 18.1253 12.1751 18.0595 12.0578 17.9422C11.9405 17.8249 11.8747 17.6659 11.8747 17.5C11.8747 17.3341 11.9405 17.1751 12.0578 17.0578L14.7414 14.375H5C4.83424 14.375 4.67527 14.3092 4.55806 14.1919C4.44085 14.0747 4.375 13.9158 4.375 13.75V2.5C4.375 2.33424 4.44085 2.17527 4.55806 2.05806C4.67527 1.94085 4.83424 1.875 5 1.875C5.16576 1.875 5.32473 1.94085 5.44194 2.05806C5.55915 2.17527 5.625 2.33424 5.625 2.5V13.125H14.7414L12.0578 10.4422C11.9405 10.3249 11.8747 10.1659 11.8747 10C11.8747 9.83415 11.9405 9.67509 12.0578 9.55781C12.1751 9.44054 12.3341 9.37465 12.5 9.37465C12.6659 9.37465 12.8249 9.44054 12.9422 9.55781L16.6922 13.3078C16.7503 13.3659 16.7964 13.4348 16.8279 13.5107C16.8593 13.5865 16.8755 13.6679 16.8755 13.75C16.8755 13.8321 16.8593 13.9135 16.8279 13.9893C16.7964 14.0652 16.7503 14.1341 16.6922 14.1922Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergedIcon);
export default __webpack_public_path__ + "static/media/MergedIcon.e9c5475f3a31607a50e13c3bca00539c.svg";
export { ForwardRef as ReactComponent };